import { ChangeEvent, useEffect, useMemo, useState } from 'react';
import { skipToken } from '@reduxjs/toolkit/query';

import type { AutocompleteArgs, AutocompleteMenuItem } from 'features/ui-kit';
import { Autocomplete } from 'features/ui-kit';
import { useGetEstablishmentsQuery } from 'store/api';

import { INSTITUTION } from './constants';

export const Institution = ({ ...rest }: Omit<AutocompleteArgs, 'items'>) => {
	const { value } = rest;

	// const [inputValue, setInputValue] = useState<string>(typeof value === 'string' ? value : '');
	// // Для дебаунса
	// const [debouncedInputValue, setDebouncedInputValue] = useState<string>('');

	// useEffect(() => {
	// 	const handler = setTimeout(() => {
	// 		setDebouncedInputValue(inputValue);
	// 	}, 500);

	// 	return () => clearTimeout(handler);
	// }, [inputValue]);

	const {
		data: estList,
		isLoading,
		isSuccess,
	} = useGetEstablishmentsQuery(
		{
			pageNumber: 0,
			pageSize: 100,
			sort: 'DESC',
			sortField: 'id',
			// chars: debouncedInputValue ? debouncedInputValue : undefined,
		} ?? skipToken,
	);

	const estItems: AutocompleteMenuItem[] = useMemo(() => {
		if (isSuccess && estList && Array.isArray(estList.content)) {
			return estList.content
				.filter((item) => (!value ? true : item.name.toLocaleLowerCase().startsWith(value.toLocaleLowerCase())))
				.map((item) => ({
					label: item.name,
					value: item.name,
				}));
		}

		return [];
	}, [isSuccess, estList, value]);

	// const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
	// 	setInputValue(e.target.value);
	// 	if (rest.onChange) {
	// 		rest.onChange(e);
	// 	}
	// };

	return (
		<Autocomplete hasClear placeholder={INSTITUTION} size="xl" isLoading={isLoading} items={estItems} {...rest} />
	);
};
